import { apiClient } from '../services/api'

export async function downloadBlob(
  url: string,
  filenameBase: string,
  ext: string = 'xlsx',
): Promise<void> {
  const response = await apiClient.get(url, { responseType: 'blob' })

  const now = new Date()
  const datePart = now.toISOString().split('T')[0]
  const timePart = now.toTimeString().slice(0, 5).replace(':', '')

  const blobUrl = window.URL.createObjectURL(response.data)
  const a = document.createElement('a')
  a.href = blobUrl
  a.download = `${filenameBase}_${datePart}_${timePart}.${ext}`
  document.body.appendChild(a)
  a.click()
  document.body.removeChild(a)
  window.URL.revokeObjectURL(blobUrl)
}
